import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ISessionRoot } from "@/interface/dto/user.session";
import { LogOut, TicketsIcon } from "lucide-react";
import { signOut } from "next-auth/react";
import Image from "next/image";
import { FaRegUserCircle } from "react-icons/fa";

interface UserDropdownProps {
  sessionData: ISessionRoot;
}

export default function UserDropdown({ sessionData }: UserDropdownProps) {
  const userName = sessionData.user?.name || "User name";

  // const firstName = userName.split(" ")[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-2 focus:outline-none cursor-pointer ">
        <>
          {sessionData?.user?.image ? (
            <div className="size-9  rounded-full overflow-hidden">
              <Image
                src={sessionData?.user?.image}
                alt="user-image"
                width={400}
                height={400}
                className="size-full object-cover"
              />
            </div>
          ) : (
            <FaRegUserCircle
              size={24}
              className=" text-white typography-paragraph-small"
            />
          )}
        </>
        <span className="typography-paragraph-small capitalize text-white">
          {userName}
        </span>
      </DropdownMenuTrigger>

      <DropdownMenuContent className="w-40" align="end">
        <DropdownMenuItem asChild>
          <a
            className="typography-large-body font-light text-grey-700 hover:text-grey-600 cursor-pointer"
            href="/user/ticket"
          >
            <TicketsIcon /> My Tickets
          </a>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => signOut({ callbackUrl: "/", redirect: true })}
          className="typography-large-body font-light text-grey-700 focus:text-primary-600 cursor-pointer"
        >
          <LogOut /> Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
